import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component, inject } from '@angular/core';
import { MultiSubscriptionComponent } from '@ddv/common-components';
import { CustomPicklistCellRendererParams } from '@ddv/data-grid';
import { ManagerService } from '@ddv/layout';
import { DropdownOption } from '@hs/ui-core-common';
import { SingleSelectDropdownComponent } from '@hs/ui-core-dropdowns';

@Component({
    selector: 'app-picklist-cell-renderer',
    templateUrl: './picklist-cell-renderer.component.html',
    styleUrls: ['./picklist-cell-renderer.component.scss'],
    host: {
        '(mousedown)': 'onClick()',
    },
    imports: [
        SingleSelectDropdownComponent,
    ],
})

export class PicklistCellRendererComponent extends MultiSubscriptionComponent implements ICellRendererAngularComp {
    private readonly manager = inject(ManagerService);

    protected value: string | undefined;
    protected dropdownOptions: DropdownOption[] = [];
    private params: CustomPicklistCellRendererParams | undefined;
    private isWidgetMaximized = false;

    agInit(params: CustomPicklistCellRendererParams): void {
        this.params = params;
        this.dropdownOptions = params.picklist?.choices ?? [];
        this.value = params.value ?? undefined;

        this.subscribeTo(this.manager.isWidgetMaximized$, (isMaximized) => {
            this.isWidgetMaximized = isMaximized;
        });
    }

    refresh(_: CustomPicklistCellRendererParams): boolean {
        return true;
    }

    protected updateDropdownValue(e: DropdownOption | undefined): void {
        this.value = e?.value ?? '';
        const colId = this.params?.colDef?.colId;
        if (colId) {
            this.params?.node.setDataValue(colId, this.value);
        }
        this.params?.api.clearCellSelection();
        this.params?.api.redrawRows({ rowNodes: [this.params?.node] });
    }

    // The children have stop propagation for the "click" event, so we need to use "mousedown" to capture the click.
    protected onClick(): void {
        if (this.params?.widgetId && !this.isWidgetMaximized) {
            this.manager.setMaximizeWidgetActionSubjectValue({ toBeMaximized: true, widgetId: this.params.widgetId });
        }
    }
}
